import {Component, OnInit} from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators, FormControl } from '@angular/forms';
import {UserService} from "./user.service";


interface User {
  firstName: string,
  lastName: string,
  phone: string,
  email: string
  // creditCards: Array,
  // savedAddresses:[]
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [UserService]
})
export class AppComponent implements OnInit {
  title = 'app';
  private customerDetailForm: FormGroup;
  private user: User = {
    firstName: "",
    lastName: "",
    phone: "",
    email: ""
  };
  private savedUser: User;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService
  ){};

  ngOnInit() {
    this.customerDetailForm = new FormGroup({
      email: new FormControl(),
      applicantFirstName: new FormControl(),
      applicantLastName: new FormControl(),
      phoneNumber: new FormControl(),
      applicantEmail: new FormControl(),
      applicantAddressStreet1: new FormControl(),
      applicantAddressStreet2: new FormControl(),
      applicantAddressCity: new FormControl(),
      applicantAddressState: new FormControl(),
      applicantAddressZip: new FormControl(),
      type: new FormControl({disabled: true})
    });
  }

    saveUser($event){

    if (this.user.email.length < 2 || this.user.phone.length < 10) {
      return false;
    }

      this.userService.saveUser(this.user).subscribe((result:any)=>{
        this.savedUser = result;
        console.log(result)
      });
    }

}




// WEBPACK FOOTER //
// C:/Users/ReedBenedian/repos/sulzer/gm-hackathon-registration/src/app/app.component.ts